<script setup lang="ts">
import { jsonLdScript } from '#shared/lib/json-ld'

const siteOrigin = useSiteOrigin()
const activeCity = useActiveCity()

const organizationJsonLd = computed<Record<string, unknown>>(() => {
  const city = activeCity.value

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${siteOrigin.value}/#organization`,
        name: 'АКПП Центр',
        url: siteOrigin.value,
      },
      {
        '@type': 'WebSite',
        '@id': `${siteOrigin.value}/#website`,
        url: siteOrigin.value,
        name: 'АКПП Центр',
        inLanguage: 'ru-RU',
        publisher: {
          '@id': `${siteOrigin.value}/#organization`,
        },
      },
      ...(city
        ? [
            {
              '@type': 'Organization',
              '@id': `${siteOrigin.value}/#city-organization`,
              name: `АКПП Центр ${city.name}`,
              url: siteOrigin.value,
              telephone: city.phone_number || undefined,
              email: city.email_value || undefined,
            },
          ]
        : []),
    ],
  }
})

useHead(() => ({
  script: [jsonLdScript(organizationJsonLd.value)],
}))
</script>

<template>
  <div class="bg-brand-white text-brand-dark flex min-h-dvh flex-col overflow-x-hidden text-xl">
    <HeaderSection />

    <main>
      <slot />
    </main>

    <FooterSection class="mt-auto" />
  </div>

  <ModalHost />
  <LeadNotice />
</template>
